'use client'
import { usePathname } from 'next/navigation'
import { APP_LOGIN_URL } from './redirect-utils'

const CALENDLY_URL = '/w05-calendly-demo/#calendly-booking'

/**
 * Returns the appropriate CTA URL based on the current page.
 * On /w05-calendly-demo, returns Calendly URL, otherwise returns login URL.
 */
export function useCTAUrl(): {href: string, isCalendly: boolean} {
  const pathname = usePathname()
  const isCalendly = pathname.includes('calendly')

  if (pathname.startsWith('/w05-calendly-demo')) {
    return {href: CALENDLY_URL, isCalendly: true}
  }
  
  return {href: APP_LOGIN_URL, isCalendly: false}
}
